export const OCCUPIED = 'OCCUPIED';
export const AVAILABLE = 'AVAILABLE';
export const RESERVED = 'RESERVED';
export const SERVING = 'SERVING';
export const SERVED = 'SERVED';
export const PROCESSING = 'PROCESSING';
